import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { TextareaProps } from ".";

export const textareaWrapperCSS = ({
  isError,
  isFocus,
  minHeight,
  characterCount,
}: Pick<TextareaProps, "isError" | "characterCount"> & { isFocus?: boolean; minHeight?: string }) =>
  css({
    position: "relative",

    display: "flex",
    flexDirection: "column",

    width: "100%",
    padding: vars.spacing[3],
    paddingBottom: vars.spacing[characterCount ? 2 : 3],
    backgroundColor: vars.semantic.color[isError ? "surfaceCritical" : "surface"],
    borderRadius: vars.rounded.medium,
    outlineColor: vars.semantic.color[isFocus ? "focus" : "border"],
    outlineWidth: "1px",

    "&:has(textarea:disabled)": {
      backgroundColor: vars.semantic.color.fieldDisabled,
      outline: "none",
    },

    "&:not(:hover)": {
      outlineWidth: isError ? "0" : "1px",
    },

    outlineStyle: "solid",
    minHeight,

    "&:has(textarea:focus)": {
      outlineWidth: "2px",
      backgroundColor: vars.semantic.color.surface,
    },

    "&:not(:has(textarea:focus, textarea:disabled)):hover": {
      outlineColor: vars.semantic.color[isError ? "borderCriticalHover" : "borderHover"],
    },
  });

export const textareaCSS = css({
  width: "100%",
  flex: 1,

  padding: 0,

  border: "none",

  resize: "none",
  outline: "none",
  backgroundColor: "transparent",

  "&:disabled": {
    cursor: "not-allowed",
    backgroundColor: "unset",
  },

  ...vars.semantic.typography["body-medium"],

  "&:placeholder": {
    color: vars.semantic.color.textSub,
  },

  "::-webkit-scrollbar": {
    display: "none",
  },
});

export const maxLengthCSS = css({
  display: "flex",
  justifyContent: "flex-end",
  background: "transparent",
});
